import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _ArcGisTerrainCatalogItem;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed, makeObservable, observable } from "mobx";
import ArcGISTiledElevationTerrainProvider from "terriajs-cesium/Source/Core/ArcGISTiledElevationTerrainProvider";
import Credit from "terriajs-cesium/Source/Core/Credit";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import ArcGisTerrainCatalogItemTraits from "../../../Traits/TraitsClasses/ArcGisTerrainCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
let ArcGisTerrainCatalogItem = (_class = (_ArcGisTerrainCatalogItem = class ArcGisTerrainCatalogItem extends UrlMixin(MappableMixin(CatalogMemberMixin(CreateModel(ArcGisTerrainCatalogItemTraits)))) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "_private_terrainProvider", _descriptor, this);
    makeObservable(this);
  }
  get type() {
    return ArcGisTerrainCatalogItem.type;
  }
  get mapItems() {
    const provider = this._private_terrainProvider;
    if (provider) {
      // ArcGISTiledElevationTerrainProvider has no official way to override the
      // credit, so we write directly to the private field here.
      if (this.attribution) provider._credit = new Credit(this.attribution);
      return [provider];
    } else {
      return [];
    }
  }
  forceLoadMapItems() {
    if (this.url === undefined) return Promise.resolve();
    return ArcGISTiledElevationTerrainProvider.fromUrl(this.url).then(terrainProvider => {
      this._private_terrainProvider = terrainProvider;
    });
  }
}, _defineProperty(_ArcGisTerrainCatalogItem, "type", "arcgis-terrain"), _ArcGisTerrainCatalogItem), _descriptor = _applyDecoratedDescriptor(_class.prototype, "_private_terrainProvider", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _class);
export { ArcGisTerrainCatalogItem as default };